import {
	Button,
	Flex,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
} from '@chakra-ui/react'
import { GetIcon, Icons } from '@ds/Icons'
import { ddsTokens } from '@ds/index'
import { DDSTheme } from '@ds/index'

import { TimeFrame } from '../types'
import { DATE_RANGE_PRESETS } from '../utils'
interface DateRangePickerProps {
	preset: TimeFrame
	onPresetChange: (preset: TimeFrame) => void
}

export const DateRangePicker = ({
	preset,
	onPresetChange,
}: DateRangePickerProps) => {
	const options = Object.entries(DATE_RANGE_PRESETS).map(([key, label]) => ({
		value: key as TimeFrame,
		label: label,
	}))
	const tokens = ddsTokens[DDSTheme.light]

	const currentValue = options.find((option) => option.value === preset)

	return (
		<Flex alignItems="center" gap={2}>
			<Menu placement="bottom-end">
				<MenuButton
					as={Button}
					rightIcon={<GetIcon icon={Icons.chevron_down} boxSize={4} />}
					bg="white"
					border={`1px solid ${tokens.primitive.light.gray[300]}`}
					borderRadius="md"
					height="35px"
					minWidth="120px"
					fontWeight="medium"
					fontSize="14px"
					pl={2}
				>
					{currentValue?.label || 'Select'}
				</MenuButton>
				<MenuList zIndex={9999}>
					{options.map((option) => (
						<MenuItem
							key={option.value}
							onClick={() => onPresetChange(option.value as TimeFrame)}
						>
							{option.label}
						</MenuItem>
					))}
				</MenuList>
			</Menu>
		</Flex>
	)
}
